
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Cruising from './components/Cruising';
import Racing from './components/Racing';
import Training from './components/Training';
import Gallery from './components/Gallery';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Sail Rebels',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/1756bc428030c15c9550206997745a72.jpeg',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+905343706433',
          contactType: 'customer service',
          areaServed: 'TR',
          availableLanguage: ['English', 'Turkish', 'French'],
        },
        {
          '@type': 'ContactPoint',
          telephone: '+33652515504',
          contactType: 'customer service',
          areaServed: 'FR',
          availableLanguage: ['English', 'French'],
        },
      ],
      email: 'info@sailrebels.com',
      sameAs: ['https://instagram.com/sailrebels/'],
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Gocek',
        addressRegion: 'Mugla',
        addressCountry: 'TR',
      },
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#localbusiness`,
      name: 'Sail Rebels',
      description:
        'Sail Rebels offers premium sailing cruising adventures, competitive racing programs, and professional training in Gocek, Turkey. Expert skippers, yacht delivery, and navigation routing for all skill levels.',
      url: SITE_URL,
      telephone: '+905343706433',
      email: 'info@sailrebels.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Gocek',
        addressRegion: 'Mugla',
        addressCountry: 'TR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 36.75,
        longitude: 29.1167,
      },
      priceRange: '$$',
      image:
        'https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/e9d990f641b70b26003270f0227366e0.jpeg',
      sameAs: ['https://instagram.com/sailrebels/'],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'Sail Rebels',
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: 'Sail Rebels | Sailing Cruising, Racing & Training in Gocek Turkey',
      description:
        'Sail Rebels offers premium sailing cruising adventures, competitive racing programs, and professional training in Gocek, Turkey.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#organization` },
      inLanguage: 'en',
    },
    {
      '@type': 'ItemList',
      name: 'Sail Rebels Services',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Yacht Cruising',
          description: 'Premium cruising adventures along the Turkish coast.',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Sailing Racing Programs',
          description: 'Competitive racing programs for all experience levels.',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'Sailing Training',
          description: 'Professional sailing training and race training courses.',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: 'Professional Yacht Delivery',
          description: 'Expert yacht delivery services across the Mediterranean.',
        },
        {
          '@type': 'ListItem',
          position: 5,
          name: 'Professional Skipper Services',
          description: 'Certified skipper services for your sailing needs.',
        },
        {
          '@type': 'ListItem',
          position: 6,
          name: 'Navigation & Weather Routing',
          description: 'Expert navigation and weather routing for safe passages.',
        },
      ],
    },
  ],
};

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const scriptId = 'schema-jsonld-home';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaJsonLd);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Cruising />
      <Racing />
      <Training />
      <Gallery />
      <AboutUs />
      <Contact />
      <Footer />
    </div>
  );
}
